<template>
  <EXTooltip
    placement="top"
    :title="title"
    :description="description"
    :delay="200"
    show-on-child-focus
  >
    <button
      type="button"
      class="not-allowed-reason"
      :aria-label="ariaLabel"
      @click="emit('open', targetId)"
    >
      {{ label }}
    </button>
  </EXTooltip>
</template>

<script setup>
import { computed } from "vue";

import EXTooltip from "@components/tooltip/EXTooltip.vue";

const props = defineProps({
  /** Tooltip title, e.g. "A proposal is already open". */
  title: {
    type: String,
    required: true,
  },
  /** Tooltip body. */
  description: {
    type: String,
    default: "",
  },
  /** Id of the blocking item, handed back on `open`. */
  targetId: {
    type: [Number, String],
    default: null,
  },
  label: {
    type: String,
    default: "Not allowed",
  },
});

const emit = defineEmits(["open"]);

const ariaLabel = computed(() => `${props.label}. ${props.title}`);
</script>

<style scoped>
.not-allowed-reason {
  padding: 2px 4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #344054;
  text-decoration: underline dotted;
  text-underline-offset: 3px;
  white-space: nowrap;
  cursor: pointer;
}

.not-allowed-reason:focus-visible {
  outline: 2px solid #7f56d9;
  outline-offset: 1px;
}
</style>
